module.exports = __webpack_public_path__ + "img/54.94fd1036.jpg";